/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalServiceItem
 */
export interface AdditionalServiceItem {
    /**
     * 附加服务ID
     * @type {number}
     * @memberof AdditionalServiceItem
     */
    additionalServiceId?: number;
    /**
     * 附加服务金额
     * @type {number}
     * @memberof AdditionalServiceItem
     */
    amount?: number;
    /**
     * 货币代码
     * @type {string}
     * @memberof AdditionalServiceItem
     */
    currencyCode?: string;
}

/**
 * Check if a given object implements the AdditionalServiceItem interface.
 */
export function instanceOfAdditionalServiceItem(value: object): value is AdditionalServiceItem {
    return true;
}

export function AdditionalServiceItemFromJSON(json: any): AdditionalServiceItem {
    return AdditionalServiceItemFromJSONTyped(json, false);
}

export function AdditionalServiceItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalServiceItem {
    if (json == null) {
        return json;
    }
    return {
        
        'additionalServiceId': json['additionalServiceId'] == null ? undefined : json['additionalServiceId'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
    };
}

export function AdditionalServiceItemToJSON(json: any): AdditionalServiceItem {
    return AdditionalServiceItemToJSONTyped(json, false);
}

export function AdditionalServiceItemToJSONTyped(value?: AdditionalServiceItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'additionalServiceId': value['additionalServiceId'],
        'amount': value['amount'],
        'currencyCode': value['currencyCode'],
    };
}

